<template lang="pug">
  div(style="position: relative")
    v-autocomplete(
      ref="autocomplete",
      :loading="loading",
      :items="pagination.data",
      :label="`${$t('Common.searchBy')} ${search.field}`",
      :filter="filtering",
      :item-text="$lcfirst(search.field)",
      :disabled="disabled"
      return-object,
      :no-filter="emit"
      append-outer-icon="mdi-magnify-plus",
      @click:append-outer="clickAndFocus()",
      v-model="value",
      @update:search-input="searchEntries($event)"
      :hide-no-data="emit"
      :no-data-text="$t('Common.noDataSearch')"
     )
      template(v-slot:item="{ item }")
        span {{ item && item[$lcfirst(search.field)] }} - {{ item && item.uid }}
      template(v-slot:progress)
        span
          strong {{$t('Common.loading')}}
    v-select(
      ref="fields",
      v-model="search.field",
      :items="enabledFields",
      :disabled="disabled"
      item-text="name",
      item-value="name",
      v-if="selecting",
      @input="unselect",
      style="position: absolute; width: 100%; top: 0; left: 0; background-color: white"
    )

</template>

<script>
import axios from 'axios'

export default {
  name: 'entity-auto-complete',
  props: ['entity', 'emit', 'init', 'whereCustom', 'disabled', 'searchField'],
  data () {
    return {
      loading: false,
      value: null,
      selecting: false,
      timer: 0,
      wait: 500,
      pagination: {
        data: this.init && this.init.uid ? [this.init] : []
      },
      search: {
        field: this.searchField || this.getDefaultField(),
        value: ''
      },
    }
  },
  watch: {
    value (value) {
      this.$emit('input', value)
    },
    init (init) {
      if(init) {
        this.value = init
        if (!init.uid) {
          init[this.getDefaultField()] = null
          this.searchEntries('')
        }
        if (this.pagination.data.length === 0) {
          this.pagination.data = [init]
        }
      }
    }
  },
  computed: {
    where () {
      if (this.enabledFields.find(f => f.name == this.search.field).type === 'String')
        return `${this.search.field}.Contains("${this.search.value}")`;
      return `${this.search.field} = ${this.search.value || "null"}`;
    },
    enabledFields() {
      return this.entity.fields.filter(f => f.name !== 'Uid');
    },
  },
  methods: {
    getDefaultField() {
      if((this.entity.fields || []).find(x => x.name === 'name')) return 'name';
      const firstName = _.get(this.entity, 'fields[0].name');
      if (firstName) {
        return firstName !== 'uid' ? firstName : _.get(this.entity, 'fields[1].name');
      }
      return null;
    },
    filtering (item, queryText, itemText) {
      if(this.search.field === '')
        return
      else
        return item && item[this.$lcfirst(this.search.field)] && item[this.$lcfirst(this.search.field)].match(queryText)
    },
    unselect () {
      this.selecting = false
      this.$refs.autocomplete.$el.querySelector('input').click()
      this.$refs.autocomplete.$el.querySelector('input').focus()
    },
    clickAndFocus () {
      this.selecting = true
      // this.$refs.fields.$el.querySelector('.v-select__selections').click()
    },
    async searchEntries (search) {
      this.loading = true
      if(typeof search === 'object') { this.loading = false; return; }
      this.search.value = search
      if (!this.search.field) { this.loading = false; return; }
      if(this.value && search === this.value[this.$lcfirst(this.search.field)]) { this.loading = false; return; }
      if (!this.emit) {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          let wheres = [this.where]
          this.loading = false
          if (this.whereCustom !== undefined && Array.isArray(this.whereCustom)) wheres = wheres.concat(this.whereCustom)
          this.pagination = (await axios.get(this.entity.name,
            { params: { where: wheres }})).data
        }, this.wait)
      } else {
        this.loading = false
        this.$emit('input', this.where)
      }
    }
  },

  created () {
    if (this.value === null && this.init && this.init.uid) {
      this.value = this.init
      this.pagination.data = [this.init]
    }
  }
}
</script>
